import React from "react";
import { NavLink, Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";

function Top() {
  return (
    <Navbar expand="md" bg="dark" data-bs-theme="dark" sticky="top">
      <Container>
        <Navbar.Brand href="/">GrüneWege</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              as={NavLink}
              to="/beratung&planung"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              Beratung & Planung
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/galabau"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              GaLa-Bau
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/pflege&erhalt"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
            >
              Pflege & Erhalt
            </Nav.Link>
          </Nav>
          {/* Kontakt Button */}
          <Button
            as={Link}
            to="/kontakt"
            variant="outline-light"
            className="ms-2"
          >
            Kontakt
          </Button>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Top;
